import React from 'react';
import { Link } from 'react-router';
import { motion } from 'framer-motion';
import TrainerLayout from '../../components/trainer/TrainerLayout';
import { Users, Clock, Star, ChevronRight, BookOpen } from 'lucide-react';

const myCourses = [
  {
    id: 1,
    title: 'AI for Finance',
    slug: 'ai-for-finance',
    students: 342,
    rating: 4.9,
    duration: '12 weeks',
    status: 'active',
    nextSession: 'Sat, May 24 - 10:00 AM',
    progress: 58,
  },
  {
    id: 2,
    title: 'Data Science for Banking',
    slug: 'data-science-banking',
    students: 128,
    rating: 4.7,
    duration: '10 weeks',
    status: 'active',
    nextSession: 'Wed, May 28 - 7:00 PM',
    progress: 35,
  },
  {
    id: 3,
    title: 'Python for FP&A',
    slug: 'python-fpa',
    students: 0,
    rating: 0,
    duration: '8 weeks',
    status: 'upcoming',
    nextSession: 'Starts June 15',
    progress: 0,
  },
];

export default function TrainerCourses(): React.JSX.Element {
  return (
    <TrainerLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-2xl font-bold text-slate-900">My Courses</h1>
          <p className="text-sm text-slate-500">Manage your assigned courses</p>
        </div>

        <div className="grid gap-6">
          {myCourses.map((course, i) => (
            <motion.div
              key={course.id}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.1 }}
              className="bg-white rounded-2xl border border-slate-100 p-6 hover:shadow-lg transition-all"
            >
              <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
                <div className="flex items-center gap-4">
                  <div className="w-14 h-14 rounded-2xl bg-amber-100 flex items-center justify-center">
                    <BookOpen className="w-7 h-7 text-amber-500" />
                  </div>
                  <div>
                    <div className="flex items-center gap-2">
                      <h3 className="text-lg font-bold text-slate-900">{course.title}</h3>
                      <span className={`px-2 py-0.5 rounded-full text-xs font-bold ${
                        course.status === 'active' ? 'bg-green-50 text-green-700' : 'bg-amber-50 text-amber-700'
                      }`}>
                        {course.status}
                      </span>
                    </div>
                    <div className="flex items-center gap-4 mt-1 text-sm text-slate-500">
                      <span className="flex items-center gap-1"><Users className="w-3.5 h-3.5" /> {course.students} students</span>
                      {course.rating > 0 && <span className="flex items-center gap-1"><Star className="w-3.5 h-3.5 text-amber-400" /> {course.rating}</span>}
                      <span className="flex items-center gap-1"><Clock className="w-3.5 h-3.5" /> {course.duration}</span>
                    </div>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <div className="text-right">
                    <p className="text-xs text-slate-500">Next Session</p>
                    <p className="text-sm font-semibold text-slate-900">{course.nextSession}</p>
                  </div>
                  <Link
                    to={`/courses/${course.slug}`}
                    className="p-2 rounded-xl bg-amber-50 text-amber-500 hover:bg-amber-100 transition-colors"
                  >
                    <ChevronRight className="w-5 h-5" />
                  </Link>
                </div>
              </div>

              {course.status === 'active' && (
                <div className="mt-4 pt-4 border-t border-slate-100">
                  <div className="flex items-center justify-between text-xs mb-1">
                    <span className="text-slate-500">Course Progress</span>
                    <span className="font-bold text-slate-900">{course.progress}%</span>
                  </div>
                  <div className="h-2 bg-slate-100 rounded-full overflow-hidden">
                    <div className="h-full bg-amber-500 rounded-full" style={{ width: `${course.progress}%` }} />
                  </div>
                </div>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </TrainerLayout>
  );
}
